import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './contexts/LanguageContext';
import { EditorProvider } from './contexts/EditorContext';
import { Toaster } from './components/ui/toaster';
import HomePage from './pages/HomePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import GDPRCompliance from './pages/GDPRCompliance';
import PartnersPage from './pages/PartnersPage';
import MaintenanceWrapper from './components/MaintenanceWrapper';
import CookieConsent from './components/CookieConsent';
import SEOManager from './components/SEOManager';
import { usePageTracking } from './hooks/usePageTracking';
import {
  LanguageRouteSync,
  RootRedirect,
  PrefixRedirect,
} from './components/LanguageRouter';

// Component to enable page tracking inside Router
const PageTracker = ({ children }) => {
  usePageTracking();
  return children;
};

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <EditorProvider>
          <Router>
            <PageTracker>
            <MaintenanceWrapper>
              <Routes>
                {/* Root — redirect to default/stored language */}
                <Route path="/" element={<RootRedirect />} />

                {/* Legacy unprefixed routes — redirect to prefixed equivalents */}
                <Route path="/partners" element={<PrefixRedirect to="/partners" />} />
                <Route path="/privacy" element={<PrefixRedirect to="/privacy" />} />
                <Route path="/terms" element={<PrefixRedirect to="/terms" />} />
                <Route path="/cookie-policy" element={<PrefixRedirect to="/cookie-policy" />} />
                <Route path="/gdpr" element={<PrefixRedirect to="/gdpr" />} />

                {/* Language-prefixed routes */}
                <Route
                  path="/:lang"
                  element={
                    <LanguageRouteSync>
                      <SEOManager />
                      <HomePage />
                    </LanguageRouteSync>
                  }
                />
                <Route
                  path="/:lang/partners"
                  element={
                    <LanguageRouteSync>
                      <SEOManager />
                      <PartnersPage />
                    </LanguageRouteSync>
                  }
                />
                <Route
                  path="/:lang/privacy"
                  element={
                    <LanguageRouteSync>
                      <SEOManager />
                      <PrivacyPolicy />
                    </LanguageRouteSync>
                  }
                />
                <Route
                  path="/:lang/terms"
                  element={
                    <LanguageRouteSync>
                      <SEOManager />
                      <TermsOfService />
                    </LanguageRouteSync>
                  }
                />
                <Route
                  path="/:lang/cookie-policy"
                  element={
                    <LanguageRouteSync>
                      <SEOManager />
                      <CookiePolicy />
                    </LanguageRouteSync>
                  }
                />
                <Route
                  path="/:lang/gdpr"
                  element={
                    <LanguageRouteSync>
                      <SEOManager />
                      <GDPRCompliance />
                    </LanguageRouteSync>
                  }
                />
              </Routes>
            </MaintenanceWrapper>
            <Toaster />
            <CookieConsent />
            </PageTracker>
          </Router>
        </EditorProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
